import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IBlokTest } from 'modules/blok-test';

interface IOlympicTest {
  data?: IBlokTest | null;
  isRunning: boolean;
}

const initialState: IOlympicTest = {
  data: null,
  isRunning: false
};

const olympicTestSlice = createSlice({
  name: 'olympic-test',
  initialState,
  reducers: {
    setOlympicTestData(state, action: PayloadAction<IBlokTest>) {
      state.data = action.payload;
    },
    startTimer(state) {
      state.isRunning = true;
    },
    stopTimer(state) {
      state.isRunning = false;
    }
  }
});

export const { setOlympicTestData, startTimer, stopTimer } = olympicTestSlice.actions;
export default olympicTestSlice.reducer;
